import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * T4 — `/pago/actualizar` (liga del correo de cobro rechazado): con sesión de administrador
 * pide una sesión fresca del portal de Stripe y redirige ahí para actualizar la tarjeta.
 */
export function UpdateCardRedirect({ isAdmin }: { isAdmin: boolean }) {
  const [error, setError] = useState<string | null>(
    isAdmin ? null : 'Solo el administrador del negocio puede actualizar la tarjeta.',
  );

  useEffect(() => {
    if (!isAdmin) return;
    let cancelled = false;
    api<{ url: string }>('/billing/portal-session', { method: 'POST', body: {} })
      .then((r) => { if (!cancelled) window.location.replace(r.url); })
      .catch((e: unknown) => {
        if (!cancelled) setError((e as Error)?.message || 'No pudimos abrir el portal de pagos.');
      });
    return () => { cancelled = true; };
  }, [isAdmin]);

  const goHome = () => { window.location.href = '/'; };

  return (
    <div className="min-h-screen grid place-items-center bg-[#FAFAF7] px-4">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 text-center">
        {error ? (
          <>
            <p className="text-sm text-slate-700">{error}</p>
            <button
              onClick={goHome}
              className="mt-4 rounded-full bg-slate-900 px-4 py-2 text-sm font-medium text-white"
            >
              Ir a FluidSol
            </button>
          </>
        ) : (
          <p className="text-sm text-slate-500">Abriendo el portal de pagos de Stripe…</p>
        )}
      </div>
    </div>
  );
}
